export default __webpack_public_path__ + "static/media/basic-web.1627e5e1.png";